/**
 * Mobile-only click-through arrows for the feature grid's swipe carousel
 * (sections/je-feature-grid.liquid, .je-fg__grid below 750px). Scoped per
 * .je-fg section rather than a single hardcoded id, since this section
 * also renders on product pages (product.json) where more than one copy
 * could exist on the same page.
 */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.je-fg').forEach((section) => {
    const grid = section.querySelector('.je-fg__grid');
    const prevBtn = section.querySelector('[data-je-fg-prev]');
    const nextBtn = section.querySelector('[data-je-fg-next]');
    if (!grid || !prevBtn || !nextBtn) return;

    function cardStep() {
      const card = grid.querySelector('.je-fg__card');
      if (!card) return grid.clientWidth;
      const style = window.getComputedStyle(grid);
      const gap = parseFloat(style.columnGap || style.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function updateDisabledState() {
      const maxScroll = grid.scrollWidth - grid.clientWidth;
      prevBtn.disabled = grid.scrollLeft <= 1;
      nextBtn.disabled = grid.scrollLeft >= maxScroll - 1;
    }

    prevBtn.addEventListener('click', () => {
      grid.scrollBy({ left: -cardStep(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', () => {
      grid.scrollBy({ left: cardStep(), behavior: 'smooth' });
    });

    grid.addEventListener('scroll', updateDisabledState, { passive: true });
    window.addEventListener('resize', updateDisabledState);
    updateDisabledState();
  });
});
